import { SvgIcon, SvgIconProps } from "@mui/material";

const OuterIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="54px"
    height="50px"
    version="1.1"
    viewBox="0 0 54 50"
    sx={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "-webkit-optimize-contrast",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    {...props}
  >
    <path
      className="path"
      d="M1.62 20.53l9.55 -15.47c0.32,-0.52 0.76,-0.96 1.28,-1.3l3.34 -2.13c0.63,-0.41 1.38,-0.63 2.14,-0.63l18.55 0c0.75,0 1.5,0.22 2.15,0.63l3.29 2.1c0.53,0.35 0.99,0.82 1.31,1.36l9.19 15.45c0.38,0.65 0.58,1.39 0.58,2.14l0 4.2c0,0.77 -0.21,1.51 -0.6,2.17l-9.3 15.29c-0.26,0.42 -0.59,0.8 -0.98,1.1l-3.46 2.71c-0.71,0.55 -1.57,0.85 -2.47,0.85l-18.17 0c-0.8,0 -1.59,-0.25 -2.25,-0.7l-4.14 -2.84c-0.5,-0.34 -0.92,-0.79 -1.23,-1.31l-8.83 -15.11c-0.37,-0.64 -0.57,-1.37 -0.57,-2.11l0 -4.2c0,-0.78 0.22,-1.54 0.62,-2.2l0 0z"
    ></path>
    <path
      className="progress"
      d="M1.62 20.53l9.55 -15.47c0.32,-0.52 0.76,-0.96 1.28,-1.3l3.34 -2.13c0.63,-0.41 1.38,-0.63 2.14,-0.63l18.55 0c0.75,0 1.5,0.22 2.15,0.63l3.29 2.1c0.53,0.35 0.99,0.82 1.31,1.36l9.19 15.45c0.38,0.65 0.58,1.39 0.58,2.14l0 4.2c0,0.77 -0.21,1.51 -0.6,2.17l-9.3 15.29c-0.26,0.42 -0.59,0.8 -0.98,1.1l-3.46 2.71c-0.71,0.55 -1.57,0.85 -2.47,0.85l-18.17 0c-0.8,0 -1.59,-0.25 -2.25,-0.7l-4.14 -2.84c-0.5,-0.34 -0.92,-0.79 -1.23,-1.31l-8.83 -15.11c-0.37,-0.64 -0.57,-1.37 -0.57,-2.11l0 -4.2c0,-0.78 0.22,-1.54 0.62,-2.2l0 0z"
    ></path>
  </SvgIcon>
);
export default OuterIcon;
